"use client";

import { useEffect } from "react";

const FootnoteClickHandler = () => {
  useEffect(() => {
    const handleFootnoteClick = (event: Event) => {
      const target = event.target as HTMLElement;
      const li = target.closest(".footnotes ol li");

      if (!li) return;

      // li 요소의 순서(인덱스) 구하기
      const allFootnotes = document.querySelectorAll(".footnotes ol li");
      const index = Array.from(allFootnotes).indexOf(li);
      const footnoteNumber = index + 1;

      // 해당 각주 번호의 원문 위치 찾기
      const possibleSelectors = [
        `a[href="#user-content-fn-${footnoteNumber}"]`,
        `a[href="#fn-${footnoteNumber}"]`,
        `sup:has(a[href="#user-content-fn-${footnoteNumber}"])`,
        `sup:has(a[href="#fn-${footnoteNumber}"])`,
      ];

      for (const selector of possibleSelectors) {
        const originElement = document.querySelector(selector) as HTMLElement;
        if (originElement) {
          originElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });

          // 잠시 하이라이트 효과
          originElement.style.backgroundColor = "rgba(59, 130, 246, 0.2)";
          setTimeout(() => {
            originElement.style.backgroundColor = "";
          }, 1000);

          break;
        }
      }
    };

    // 각주 섹션의 li 요소들에 클릭 이벤트 추가
    const footnoteItems = document.querySelectorAll(".footnotes ol li");
    footnoteItems.forEach((item) => {
      item.addEventListener("click", handleFootnoteClick as EventListener);
    });

    // 클린업
    return () => {
      footnoteItems.forEach((item) => {
        item.removeEventListener("click", handleFootnoteClick as EventListener);
      });
    };
  }, []);

  return null; // UI를 렌더링하지 않는 컴포넌트
};

export default FootnoteClickHandler;
